import arrow_up from '../images/arrow_red.png'
import arrow_down from '../images/arrow_green.png'

export default function CardHistory({
    index,
    currency,
    amount,
    payment_type,
    updatedAt,
    description,
    status,
    class_name
}) {
    return (
        <div className={"item_history " + class_name}>
            <div className="num_item_history">
                <p>{index}</p>
            </div>
            <div className="amount_item_history">
                <p>{currency} {amount}</p>
            </div>
            <div className="payment_type_history">
                <p>{payment_type}</p>
            </div>
            <div className="date_item_history">
                <p>{updatedAt}</p>
            </div>
            <div className="description_item_history">
                <p>{description}</p>
            </div>
            <div className={"status_item_history"}>
                {status == 'Status' ?
                    <p>{status}</p>
                    : <img className={status == 0 ? '' : 'down'} src={status == 0 ? arrow_up : arrow_down} alt="" />
                }

            </div>
        </div>
    )
}